module.exports = __webpack_public_path__ + "img/logo_Hdi.833a3870.svg";